import Vue from 'vue'
import JSZip from 'jszip';

export default JSZip;


// WEBPACK FOOTER //
// ./src/plugins/jszip.js